import { render, staticRenderFns } from "./FormsTemplate.vue?vue&type=template&id=affea902&scoped=true&lang=pug"
import script from "./FormsTemplate.vue?vue&type=script&lang=ts"
export * from "./FormsTemplate.vue?vue&type=script&lang=ts"
import style0 from "./FormsTemplate.vue?vue&type=style&index=0&id=affea902&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affea902",
  null
  
)

export default component.exports